import { jsx as r, jsxs as m, Fragment as h } from "react/jsx-runtime";
import { d as p, Y as x, Z as _ } from "../../vendor-CPVnY93G.js";
import { BaseIcon as d } from "../BaseIcon/index.js";
import { Link as $ } from "../Link/index.js";
import '../../assets/index11.css';const y = "_breadcrumbs_1yf7h_1", B = "_breadcrumb_1yf7h_1", t = {
  breadcrumbs: y,
  breadcrumb: B
}, N = ({ links: e, isLandmark: b, ...f }) => {
  const i = p(t.breadcrumbs), a = /* @__PURE__ */ r(x, { className: i, "data-component": "Breadcrumbs", children: e.map((o, n) => {
    const { icon: s, children: c, ...l } = o;
    return /* @__PURE__ */ m(_, { className: t.breadcrumb, children: [
      /* @__PURE__ */ r($, { ...l, children: (u) => /* @__PURE__ */ m(h, { children: [
        s && /* @__PURE__ */ r(d, { icon: s, mr: 2 }),
        typeof c == "function" ? c(u) : c
      ] }) }),
      n !== e.length - 1 && /* @__PURE__ */ r(d, { color: "moon", icon: "chevron-next", mr: 2, ml: 2 })
    ] }, o.href || n);
  }) });
  return b ? /* @__PURE__ */ r("nav", { "aria-label": f["aria-label"], children: a }) : a;
};
export {
  N as Breadcrumbs
};
